import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonPage,
  IonRange,
  IonRow,
  IonSelect,
  IonSelectOption,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import "../shared/css/AppHeader.css";
import "../shared/css/ResultBox.css";
import Logic, { IAspectRatioInfo, asInfos } from "./Logic";
import myUtil from "../../helpers/cha-utils";
import MyIonInput from "../shared/components/MyIonInput";
import "../../theme/table.css";
import SharedLogic from "../shared/SharedLogic";
import {
  checkmark,
} from "ionicons/icons";
import { useHistory } from "react-router";

const Index: React.FC = () => {
  const [data, setData] = useState(Logic.getDefaultData());
  const [preset, setPreset] = useState("");
  const [isCustomAS, setIsCustomAS] = useState(true);

  const presetData: IAspectRatioInfo | null = preset
    ? asInfos.find((item) => item.key === preset) ?? asInfos[0]
    : null;

  useEffect(() => {
    applyPreset();
    console.log("Apply Preset: " + preset);
  }, [preset]);

  const applyPreset = () => {
    if (presetData) {
      let newData = { ...data };
      Logic.setDataItemValue(newData.asWidth, presetData.width);
      Logic.setDataItemValue(newData.asHeight, presetData.height);
      autoCalculate(newData, "asWidth");
      setData(newData);
      setIsCustomAS(false);
    }
  };

  const handleInputChange = (dataKey: string, userValue: any) => {
    let userShow = myUtil.formatNumber(userValue);
    if (userValue === "") userShow = "";
    let nativeValue = +userValue;

    const dataItemKey = dataKey as keyof typeof data;
    const newData = { ...data, [dataKey]: { ...data[dataItemKey] } };

    const newDataItem = newData[dataItemKey];

    newDataItem.input = userValue;
    newDataItem.show = myUtil.formatNumber(userValue);
    newDataItem.value = nativeValue;

    autoCalculate(newData, dataKey);

    setData(newData);
  };

  const autoCalculate = (newData: typeof data, dataKey: string) => {
    if (data.asWidth.value && data.asHeight.value) {
      let newWidth,
        newHeight = 0;
      switch (dataKey) {
        case "asWidth":
        case "asHeight":
        case "width":
          newHeight = SharedLogic.calculateHeight(
            newData.width.value,
            newData.asWidth.value,
            newData.asHeight.value
          );
          Logic.setDataItemValue(newData.height, newHeight);
          break;
        case "height":
          newWidth = SharedLogic.calculateWidth(
            newData.height.value,
            newData.asWidth.value,
            newData.asHeight.value
          );
          Logic.setDataItemValue(newData.width, newWidth);
          break;
      }
    }
  };

  const asInfoJSX = asInfos.map((item) => (
    <IonSelectOption key={item.key} value={item.key}>
      {item.name}
    </IonSelectOption>
  ));

  let diagonalValue = undefined;
  if (data.width.value > 0 && data.height.value > 0) {
    diagonalValue =
      myUtil.formatNumber(
        Logic.calculateDiagnal(data.width.value, data.height.value)
      ) + " px";
  }

  const history = useHistory();

  const moreInfo = () => {
    if (!data.width.value) return;
    history.push(
      `/apps/as/${data.asWidth.value}/${data.asHeight.value}/${data.width.value}`
    );
  };

  return (
    <IonPage className="appPage">
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton />
          </IonButtons>
          <IonTitle>Custom Aspect Ratio</IonTitle>
        </IonToolbar>
      </IonHeader>
      {/* <IonContent fullscreen scrollEvents={true} onIonScroll={(e) => handleContentScroll(e.detail.scrollTop)}> */}
      <IonContent fullscreen={true} id="mainContent">
        {/* Show Header only when in app mode */}
        {/* {SharedConfig.isShowHeader && <AppHeader title="Waist-Hip Ratio" subTitle="WHR Calculator" ionIconSrc="/assets/icons/ppi/icon.svg" />} */}
        <IonGrid fixed>
          <IonRow>
            <IonCol>
              <IonCard>
                <IonCardHeader color="primary">
                  <IonCardSubtitle>
                    Choose or enter an aspect ratio{" "}
                  </IonCardSubtitle>
                </IonCardHeader>
                <IonCardContent className="ion-no-padding">
                  <div className="ion-padding">
                    {[
                      "16:9",
                      "16:10",
                      "21:9",
                      "32:9",
                      "3:2",
                      "4:3",
                      "5:4",
                      "1:1",
                    ].map((item) => (
                      <IonButton
                        onClick={() => setPreset(item)}
                        fill={preset === item ? "solid" : "outline"}
                        size="small"
                        key={item}
                      >
                        {item}
                      </IonButton>
                    ))}
                    <IonButton
                      onClick={() => {
                        setIsCustomAS(true);
                        setPreset("");
                      }}
                      fill={preset === "" ? "solid" : "outline"}
                      size="small"
                    >
                      Custom
                    </IonButton>
                  </div>

                  <IonList className="ion-no-padding" lines="none">
                    {isCustomAS && (
                      <IonItem>
                        <IonGrid className="ion-no-padding">
                          <IonRow className="ion-align-items-top">
                            <IonCol className="expandableRange">
                              <MyIonInput
                                aria-label="AS Width"
                                cId="asWidth"
                                data={data.asWidth}
                                onMyChange={handleInputChange}
                                fill="outline"
                              />
                              <IonRange
                                aria-label="asWidth"
                                min={0}
                                max={32}
                                value={data.asWidth.value}
                                snaps={true}
                                onIonInput={(e: any) =>
                                  handleInputChange("asWidth", e.detail.value)
                                }
                              />
                            </IonCol>
                            <IonCol
                              size="auto"
                              className="ion-padding-horizontal"
                              style={{ paddingTop: "17px" }}
                            >
                              <IonLabel>:</IonLabel>
                            </IonCol>
                            <IonCol className="expandableRange">
                              <MyIonInput
                                aria-label="AS Height"
                                cId="asHeight"
                                data={data.asHeight}
                                onMyChange={handleInputChange}
                                fill="outline"
                              />
                              <IonRange
                                aria-label="asHeight"
                                min={0}
                                max={32}
                                snaps={true}
                                value={data.asHeight.value}
                                onIonInput={(e) =>
                                  handleInputChange("asHeight", e.detail.value)
                                }
                              />
                            </IonCol>
                          </IonRow>
                          <IonRow>
                            <IonCol></IonCol>
                          </IonRow>
                        </IonGrid>
                      </IonItem>
                    )}
                    <IonItem>
                      <IonSelect
                        value={preset}
                        interface="alert"
                        aria-label="Screen Info"
                        selectedText={presetData && presetData.name}
                        onIonChange={(e) => setPreset(e.detail.value)}
                        label="Presets"
                        placeholder="Select Here"
                        labelPlacement="start"
                      >
                        {asInfoJSX}
                      </IonSelect>
                    </IonItem>
                  </IonList>
                </IonCardContent>
              </IonCard>
              {data.asWidth.value > 0 && data.asHeight.value > 0 ? (
                <IonGrid>
                  <IonRow>
                    <IonCol></IonCol>
                    <IonCol>
                      <div className="ion-text-right">
                        <IonButton
                          routerLink={`/apps/as/${data.asWidth.value}/${data.asHeight.value}`}
                          size="large"
                          expand="block"
                        >
                          <IonIcon icon={checkmark} slot="start" /> Use{" "}
                          {data.asWidth.value}:{data.asHeight.value}
                        </IonButton>
                      </div>
                    </IonCol>
                  </IonRow>
                </IonGrid>
              ) : (
                <IonCard>
                  <IonCardHeader color="warning">
                    <IonCardSubtitle>ℹ️ Instructions</IonCardSubtitle>
                  </IonCardHeader>
                  <IonCardContent>
                    <p className="ion-padding-top">
                      Select an aspect ratio from the available presets, or use
                      the "Custom" button to enter it manually.
                    </p>
                  </IonCardContent>
                </IonCard>
              )}
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default Index;
